import * as React from 'react';
import {Link} from 'react-router';

export class Dashboard extends React.Component<{}, {table: string}> {
    constructor(props) {
        super(props);
        this.state = {table: ''};
    }
    
    private changeTable(e) {
        this.setState({table: e.target.value});
    }
    
    private openTable(e) {
        e.preventDefault();
        if (this.state.table) {
            window.open('/table/' + this.state.table, '_blank');
        }
    }
    
    public render() {
        return (
            <div className="dashboard">
                <h1>Конференция LOUDHEAD 2016</h1>
                <div><p>На этой странице можно открыть инструменты для регистрации участников и систему для голосования за стол.</p></div>
                
                <div>
                    <Link className="go" to="/dashboard/accounting">Регистрация участников</Link>
                </div>
                
                <form>
                    <input onChange={e => this.changeTable(e)} type="text" value={this.state.table} placeholder="Введите номер стола" />&nbsp;
                    {this.state && this.state.table && <button onClick={e => this.openTable(e)}>Открыть голосование за стол</button>}
                </form>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/Dashboard.tsx
 **/